'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("pillInterfacageEcheance", function ($montantFormat) {
  return {
    restrict: "E",
    replace: true,
    scope: {
      interfacage: "="
    },
    template: '<span title="{{::title}}" class="pill-mandatement-echeance icon-mandatement-{{::interfacage.etat}}-{{::interfacage.montantAChange}}">{{description}}</span>',
    link: function link($scope, $el, $attrs, controller) {
      if ($scope.interfacage.etat === 'AUCUN') {
        $scope.title = $scope.description = "Non transféré";
      }
      var description = function description(libelleEtat, interfacage) {
        if (interfacage.montantAChange) {
          return libelleEtat + " : " + $montantFormat.montant(interfacage.montantMandate, 2) + ", actuel : " + $montantFormat.montant(interfacage.montant, 2);
        }
        return libelleEtat;
      };
      var title = function title(libelleEtat, interfacage) {
        var title = '';
        if (interfacage.infoComplementaireDuRetour) {
          title += interfacage.infoComplementaireDuRetour;
        }
        if (interfacage.montantAChange) {
          title += "Le montant " + libelleEtat + " (" + $montantFormat.montant(interfacage.montantMandate, 2) + ") differt du montant actuel.";
        }
        return title;
      };
      if ($scope.interfacage.etat === 'REJETE') {
        $scope.description = "Rejeté";
        $scope.title = title("rejeté", $scope.interfacage);
      }
      if ($scope.interfacage.etat === 'TRANSFERE') {
        $scope.description = description("Transféré", $scope.interfacage);
        $scope.title = title("transféré", $scope.interfacage);
      }
      if ($scope.interfacage.etat === 'TRAITE') {
        $scope.description = description("Traité", $scope.interfacage);
        $scope.title = title("traité", $scope.interfacage);
      }
      if ($scope.interfacage.etat === 'ACCEPTE') {
        $scope.description = description("Accepté", $scope.interfacage);
        $scope.title = title("accepté", $scope.interfacage);
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/pills/pillInterfacageEcheance.js
// module id = 2984
// module chunks = 13